<template>
  <div class="bg-gray-200 py-2.5 w-[99vw]">
        <p class="text-dark-gray pr-52 text-end	">&copy; my Dream Place 2022</p>
  </div>
</template>

<script>
export default {

}
</script>